<template>
  <generic-modal
    size
    :title="$t('brain')"
    icon="brain"
    image="/images/icons/configuration.png"
    v-bind:footer_buttons="footer_buttons"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <generic-container
        v-for="(space, index) in spaces"
        v-bind:key="index"
        v-bind:searchable="false"
        v-bind:show_plus="true"
        icon="layer group"
        :title="space.name"
        v-on:add="add_device(space)"
        v-on:title_click="change_space_name(space)"
        v-bind:header_buttons="header_buttons"
        v-bind:object="space"
      >
        <div class="ui form">
          <div class="ui relaxed selection divided list">
            <div
              class="item"
              v-for="(device, idx) in space.devices"
              v-bind:key="idx"
            >
              <!-- <i class="large lightbulb middle aligned icon"></i>
              <div class="content">
                <a class="header">{{ device.name }}</a>
                <div class="description">Updated 10 mins ago</div>
              </div>-->
              <div class="ui form">
                <div class="fields">
                  <div class="five column wide field">
                    <label for>{{ $t("name") }}</label>
                    <input
                      type="text"
                      name="name"
                      v-model="spaces[index].devices[idx].name"
                    />
                  </div>
                  <div class="five column wide field">
                    <label for>{{ $t("gpio pin") }}</label>
                    <select
                      class="ui dropdown"
                      v-model="spaces[index].devices[idx].gpio_pin"
                    >
                      <option value>{{ $t("select pin") }}</option>
                      <option>2</option>
                      <option>3</option>
                      <option>4</option>
                      <option>5</option>
                      <option>6</option>
                      <option>7</option>
                      <option>8</option>
                      <option>9</option>
                      <option>10</option>
                      <option>11</option>
                      <option>12</option>
                      <option>13</option>
                      <option>14</option>
                      <option>15</option>
                      <option>16</option>
                      <option>17</option>
                      <option>18</option>
                      <option>19</option>
                      <option>20</option>
                      <option>21</option>
                      <option>22</option>
                      <option>23</option>
                      <option>24</option>
                      <option>25</option>
                      <option>26</option>
                      <option>27</option>
                    </select>
                  </div>
                  <div class="four column wide field">
                    <label for>{{ $t("direction") }}</label>
                    <select
                      class="ui dropdown"
                      v-model="spaces[index].devices[idx].direction"
                    >
                      <option value>{{ $t("select direction") }}</option>
                      <option value="input">{{ $t("input") }}</option>
                      <option value="output">{{ $t("output") }}</option>
                    </select>
                  </div>
                  <div class="two column wide field">
                    <label for>{{ $t("actions") }}</label>
                    <div
                      class="ui red mini icon button"
                      v-on:click.stop="remove_device(space, device, idx)"
                    >
                      <i class="trash icon"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </generic-container>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, toast, clone } from "@/utils";
import GenericModal from "@/components/GenericModal";
import GenericContainer from "@/components/GenericContainer";
import uuid from "uuid/v4";

export default {
  components: {
    "generic-modal": GenericModal,
    "generic-container": GenericContainer,
  },
  computed: {},
  data() {
    return {
      footer_buttons: [
        {
          color: "blue",
          icon: "plus",
          text: this.$i18n.t("add space"),
          click: this.add_space,
        },
      ],
      header_buttons: [
        {
          color: "red",
          icon: "trash",
          click: this.remove_space,
        },
      ],
      spaces: [],
    };
  },
  methods: {
    add_space() {
      this.spaces.push({
        id: uuid(),
        name: this.$i18n.t("space") + (this.spaces.length + 1),
        devices: [],
      });
    },
    remove_space(space) {
      let targetIndex = this.spaces.findIndex((n) => n.id == space.id);
      if (targetIndex >= 0) this.spaces.splice(targetIndex, 1);
    },
    add_device(space) {
      space.devices.push({
        id: uuid(),
        name: this.$i18n.t("device") + (space.devices.length + 1),
        gpio_pin: "",
        direction: "input",
      });
    },
    remove_device(space, device, index) {
      space.devices.splice(index, 1);
    },
    change_space_name(space) {
      this.$alertify.promptWithTitle(
        this.$i18n.t("edit name"),
        this.$i18n.t("enter space name"),
        space.name,
        (evt, value) => {
          space.name = value;
        },
        () => {},
      );
    },
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let moduleConfig = clone(vm.spaces);
        local_api(vm, "post", "/brain/do-save-configuration", {
          setup: moduleConfig,
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    destroy() {
      this.$destroy();
    },
  },
  mounted() {
    let vm = this;

    local_api(this, "post", "/brain/do-get-configuration")
      .then((config) => {
        vm.spaces = config.setup;
      })
      .catch((err) => {
        toast(this.$el, "error", err);
      });
  },
  watch: {},
  updated: function() {
    this.$nextTick(function() {
      window.jQuery(".ui.dropdown").dropdown();
    });
  },
};
</script>
